

export function displayName(firstName = '', lastName = '', first_last = true) {
	if(first_last === false) {
		return lastName + ', ' + firstName;
	} else {
		return firstName + ' ' + lastName;
	}
}

export function displayPhone(phoneString) {
	let digitString = stringToDigits(phoneString);
	return (digitString.slice(0, 3) + '.' + digitString.slice(3, 6) + '.' + digitString.slice(6, 10));
}

export function displayDateFromDbString(dbString) {
	let year = parseInt(dbString.substring(0,4));
  let month = parseInt(dbString.substring(5,7));
  let day = parseInt(dbString.substring(8,10));
  return (month) + '/' + day + '/' + year;
}

export function displayDateFromTimestamp(timestampString) {
	let d = new Date(timestampString);
	return (d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear();
}

export function displayDateTimeFromTimestamp(timestampString) {
  let d = new Date(timestampString);
  return (d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear() + ' ' + displayTimeFromTimestamp(timestampString);
}

export function displayVerboseDateFromTimestamp(timestampString) {
	let d = new Date(timestampString);
	let monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	return (monthNames[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear());
}

export function displayTimeFromTimestamp(timestampString) {
	let d = new Date(timestampString);
	let hour = d.getHours();
	let suffix = ' AM';
	if(hour > 12) {
		hour -= 12;
		suffix = ' PM';
	}
	if(hour === 0) {
		hour = 12;
	}
	let minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();

	return (hour + ':' + minutes + suffix);
}

export function stringToDigits(testString) {
	return testString.replace( /[^0-9]/g, '');
}

export function formatShape(diamond) {
  switch (diamond.shape) {
    case 'ROUNDS':
      return 'Round';
    case 'OVALS':
      return 'Oval';
    case 'EMERALD':
      return 'Emerald';
    case 'PEAR SHAPE':
      return 'Pear';
    case 'CUSHION':
      return 'Cushion';
    case 'SQUARE OR PRINCESS':
      return 'Princess';
    case 'RADIANT':
      return 'Radiant';
    case 'MARQUISE':
      return 'Marquise';
    case 'ASCHER':
      return 'Asscher';
    case 'HEART SHAPE':
      return 'Heart';
    case "L'AMOUR CUT":
      return "L'Amour Cut";
    case 'DAUSSI CUSHION':
      return 'Daussi';
    default:
      return '';
  }
}

/**
 * Store name for a diamond's location number.
 *
 * Resolved from the location list the app already fetches from /stores/locations
 * (pass `this.props.transfers.locations`), NOT from a hardcoded table. The previous
 * implementation was a switch covering only store numbers 1-37, so ECJ Watch Boutique
 * (0), Online Sales (50) and DDNY (51) fell through to '' and rendered a nameless
 * location; it also disagreed with the DB on store 36 ('Ft Worth' vs 'Fort Worth').
 * Using the DB rows keeps this correct when stores are renamed or opened.
 *
 * Falls back to the bare number rather than an empty label, which covers both the brief
 * window before the location list loads and any number with no matching store.
 */
export function formatLocation(diamond, locations) {
  if (!diamond) {
    return '';
  }
  return formatLocationNum(diamond.location, locations);
}

export function formatLocationNum(locationNum, locations) {
  // diamonds.location_num is nullable, so guard before matching.
  if (locationNum === null || locationNum === undefined || locationNum === '') {
    return '';
  }
  const match = (locations || []).find(l => Number(l.asc_id) === Number(locationNum));
  return match ? match.short_name : String(locationNum);
}

export function formatPrice(diamond) {
  return "$" + diamond.price.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatCut(diamond) {
  return diamond.cut;
}

export function formatSymmetry(diamond) {
  return diamond.symmetry;
}

export function formatPolish(diamond) {
  return diamond.polish;
}

export function formatFluorescence(diamond) {
  return diamond.flourescence;
}

export function formatMeasurements(diamond) {
  let tempMeasurements = diamond.measurements;
  return tempMeasurements.toLowerCase().substring(0,25)
}

export function formatTable(diamond) {
  return diamond.table + '%';
}

export function formatDepth(diamond) {
  return diamond.depth + '%';
}

export function formatRatio(diamond) {
  if(diamond.ratio === null) {
    return '';
  }
  return diamond.ratio.toFixed(2);
}
